import { createFileRoute } from "@tanstack/react-router";
import VideoLinkStatsContainer from "../components/VideoLinkStatsContainer";

export const Route = createFileRoute("/video/$videoId/link-stats")({
  component: RouteComponent,
});

function RouteComponent() {
  const { videoId } = Route.useParams();

  return (
    <div>
      <VideoLinkStatsContainer videoId={videoId} />
    </div>
  );
}
